<template lang="js">
<div class="setting-item">
    <span class="setting-title">{{ itemTxt }}</span>
    <div class="setting-item-container">
        <SettingItemToggle v-show="optionA" :watchValue="watchValue" :bindValue="0" :option="optionA"/>
        <SettingItemToggle v-show="optionB" :watchValue="watchValue" :bindValue="1" :option="optionB"/>
        <SettingItemToggle v-show="optionC" :watchValue="watchValue" :bindValue="2" :option="optionC"/>
    </div>
</div>
</template>
<script>

import SettingItemToggle from './SettingItemToggle.vue';

export default {
    name: "SettingItem",
    components: {
        SettingItemToggle
    },
    props: {
        watchValue: String,
        itemTxt: String,
        optionA: String,
        optionB: String,
        optionC: String
    }
}
</script>
<style lang="css" scoped>
.setting-item {
    display: grid;
    grid-template-columns: 1% 34% 65%;
    grid-template-rows: 45px;
    line-height: 45px;
    border-bottom-style: solid;
    border-bottom-color: rgb(0, 89, 173);
}

.setting-item-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.setting-title {
    grid-column-start: 2;
    text-align: start;
    color: rgb(0, 89, 173);
    font-weight: bold;
    font-size: 16pt;
}
</style>